import type { FC, ReactNode } from 'react'

import { WhatsAppLink } from '@/components/generals/whatsapp-link'
import { BuckyMascot } from '@/components/generals/bucky-mascot'

import { brand, contact, isWhatsAppEnabled } from '@/constants/content'

const ContactSection: FC = (): ReactNode => {
    return (
        <section id='contact' aria-labelledby='contact-heading' className='relative py-24 sm:py-32'>
            <div aria-hidden className='absolute inset-x-0 top-1/2 h-72 -translate-y-1/2 bg-orange/10 blur-[120px]' />

            <div className='container-site relative'>
                <div className='reveal relative overflow-hidden rounded-3xl bg-soft-white p-8 text-navy shadow-[0_50px_120px_-50px_rgb(0_0_0/0.9)] sm:p-12 lg:p-16'>
                    <div aria-hidden className='absolute -right-10 -bottom-10 opacity-[0.07] sm:-right-6 sm:-bottom-6'>
                        <BuckyMascot size={260} decorative />
                    </div>

                    <p className='text-xs font-semibold tracking-[0.18em] text-cool-grey uppercase'>
                        {contact.eyebrow}
                    </p>

                    <span className='mt-4 inline-flex items-center gap-2 rounded-full bg-navy px-3 py-1 text-xs font-semibold text-soft-white'>
                        <span className='size-2 rounded-full bg-orange' aria-hidden />
                        {contact.enquiriesStatus}
                    </span>

                    <h2 id='contact-heading' className='relative mt-5 max-w-2xl text-[2rem] leading-[1.08] font-bold tracking-[-0.025em] sm:text-5xl'>
                        {contact.heading}
                    </h2>

                    <p className='relative mt-5 max-w-xl text-lg leading-relaxed text-cool-grey'>
                        {contact.body}
                    </p>

                    <div className='relative mt-10 flex flex-col gap-6 border-t border-navy/10 pt-8 sm:flex-row sm:items-center sm:justify-between'>
                        <div className='flex items-center gap-4'>
                            <span aria-hidden className='grid size-14 place-items-center rounded-full bg-navy font-heading text-xl font-bold text-soft-white'>
                                HY
                            </span>

                            <div>
                                <p className='font-heading text-xl font-bold'>
                                    {brand.founder.name}
                                </p>

                                <p className='text-cool-grey'>
                                    {brand.founder.title}
                                </p>
                            </div>
                        </div>

                        {isWhatsAppEnabled() && (
                            <div className='flex flex-col gap-2 sm:items-end'>
                                <WhatsAppLink className='min-h-14 w-full px-8 text-base sm:w-auto' />

                                <p className='text-xs text-cool-grey sm:text-right'>
                                    {contact.whatsapp.hint}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection
